import * as React from "react";
import { useEffect, useState } from "react";
import { OwnerPage, OwnerPageResource } from "burde";
import * as styles from "./owner-page-selector-display.css";

interface Props {
    ownerPageResources: OwnerPageResource[];
    selectedResourceGroup: string;
    selectedOwnerPageId: number | null;
    onSelect: (page: OwnerPage) => any;
}

export const OwnerPageSelectorDisplay = ({
    ownerPageResources,
    selectedResourceGroup,
    onSelect,
    selectedOwnerPageId,
}: Props) => {
    const [ownerPages, setOwnerPages] = useState<OwnerPage[]>([]);

    const getOwnerPages = () => {
        const resource = ownerPageResources.find(
            (x) => x.resourceGroupTitle === selectedResourceGroup,
        );
        if (!resource) return;

        setOwnerPages(resource.ownerPages);

        if (selectedOwnerPageId === 0 && resource.ownerPages.length > 0) {
            onSelect(resource.ownerPages[0]);
        }
    };

    useEffect(() => {
        getOwnerPages();
    }, []);

    useEffect(() => {
        getOwnerPages();
    }, [selectedResourceGroup]);

    return (
        <ul className={[styles.iconPicker, styles.iconPickerSmall].join(" ")}>
            {ownerPages.map((ownerPage) => (
                <li
                    className={styles.iconPickerLi}
                    key={ownerPage.id}
                    onClick={() => {
                        onSelect(ownerPage);
                    }}>
                    <div
                        className={[
                            styles.iconPickerItem,
                            styles.iconPickerItemImageAuto,
                            selectedOwnerPageId == ownerPage.id
                                ? styles.iconPickerItemSelected
                                : "",
                        ].join(" ")}>
                        <div>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: ownerPage.endpoints.thumbnail || "",
                                }}></div>

                            {ownerPage.title ? ownerPage.title : ""}
                        </div>
                    </div>
                </li>
            ))}
        </ul>
    );
};
